/*
 * @description:
 * @author: Jason Wong
 * @since: 2021-04-08 11:18:21
 */
import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import context from "./modules/context";
import alignment from "./modules/alignment";
import permission from "./modules/permission";
import menu from "./modules/menu";
import router from "../router";
import { isBlank } from "../utils/String";
import dictionary from "./modules/dictionary";
import cat from "./modules/cat";

Vue.use(Vuex);
console.log("#-# router", router);
const store = new Vuex.Store({
    modules: {
        user,
        context,
        cat,
        alignment,
        permission,
        dictionary,
        menu,
    },
    state: {
        token: "",
        userInfo: {
            userId: "",
            userName: "",
            realName: "",
            email: "",
            phoneNumber: "",
            userType: -1,
            schoolId: "",
            schoolName: "",
            createTimeStr: "",
            portrait: "",
            systemCodes: "",
        },
        calculateFactors: {
            headerHeight: 60,
            headAndFootTotalHeight: 163,
        },
    },
    mutations: {
        onSetUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
    },
    actions: {
        onSetUserInfo(context, userInfo) {
            context.commit("onSetUserInfo", userInfo);
        },
    },
    getters: {
        authentificatedMenus(state) {
            return router.options.routes.some((r) => !r.redirect && r.path != "*");
        },
        ContentMinHeight() {
            return window.innerHeight - 163;
        },
        roles(state) {
            if (!state.user.roles) return [];
            if (typeof state.user.roles == "string") {
                return state.user.roles
                    .split(",")
                    .filter((r) => !isBlank(r))
                    .map((r) => r.trim());
            } else if (state.user.roles instanceof Array) {
                return state.user.roles;
            } else {
                return [];
            }
        },
        loginState(state) {
            return state.user.state;
        },
        usedLangauges(state) {
            return state.user.recentlyUsedLanguages;
        },
    },
});

console.log("#-# store", store);
export default store;

export { userState } from "./modules/user";
